export function removeStyleAttributesFromElement(html: HTMLElement) {
  html.style.removeProperty('color');
  html.style.removeProperty('background-color');
  html.style.removeProperty('background');
  html.removeAttribute('color');
  html.removeAttribute('background-color');

  if (!html.style.cssText.trim()) {
    html.removeAttribute('style');
  }
}

export function removeStyleAttributesFromHtml(html: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelectorAll('*').forEach((el) => {
    if (el instanceof HTMLElement) {
      removeStyleAttributesFromElement(el);
    }
  });

  return doc.body.innerHTML;
}
